import { Formik } from 'formik';
import type { FormikHelpers } from 'formik';

import { EMPTY_STRING } from '@e-socna/empty';

import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { useMissionReadyContext } from '../../contexts/MissionContext/hooks/useMissionReadyContext.hook';
import { findInitialWorkflowOfMissionWorkflow } from '../../utils/workflows-of-mission-workflow.util';
import type { AccountingInfoFormValues } from '../../pages/MissionAccounting/hooks/useInitHandler.hook';

import { MissionAccountingInfoFormFields } from './MissionAccountingInfoFormFields';

interface Props {
  readonly onSuccess?: () => void;
  readonly submitLabel?: string;
  readonly useSubmitFactory: (
    handleSuccess?: () => void,
  ) => (
    values: AccountingInfoFormValues,
    formikHelpers: FormikHelpers<AccountingInfoFormValues>,
  ) => void;
}

export const MissionAccountingInfoForm = ({
  onSuccess: handleSuccess,
  submitLabel = 'Valider',
  useSubmitFactory,
}: Readonly<Props>) => {
  const { accountingWorkflows, defaultAccountingWorkflow } =
    useReferencesContext();
  const { mission } = useMissionReadyContext();

  const initialValues: AccountingInfoFormValues = {
    workflowId: defaultAccountingWorkflow
      ? findInitialWorkflowOfMissionWorkflow(
          accountingWorkflows,
          defaultAccountingWorkflow,
          mission.workflowId,
        )._id
      : EMPTY_STRING,
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={useSubmitFactory(handleSuccess)}
    >
      <MissionAccountingInfoFormFields submitLabel={submitLabel} />
    </Formik>
  );
};
